import { ColumnsType, DeleteIcon, EditIcon, Group } from '@/components/_common';
import { useDisclosure, useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { getTableScrollX } from '@/utils/table';
import { Button, Divider, Modal, Space, Table, Typography } from 'antd';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import WhatsappTemplatesModal from './WhatsappTemplatesModal';
import { MatrixWhatsappSettings } from '@/core/domain/enterprise/MatrixWhatsappSettings/MatrixWhatsappSettings.types';
import {
  useMatrixWhatsappSettings,
  useMatrixWhatsappSettingsDelete,
} from '@/core/domain/enterprise/MatrixWhatsappSettings/MatrixWhatsappSettings.hooks';

const { Title } = Typography;

const WhatsappTemplates: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl();
  const { width } = useWindowSize();
  const [rowEdit, setRowEdit] = useState<MatrixWhatsappSettings>();
  const [modalToggle, modalToggleAction] = useDisclosure(false, {
    onClose: () => setRowEdit(undefined),
  });

  const { data, isLoading } = useMatrixWhatsappSettings();
  const { mutateAsync: remove } = useMatrixWhatsappSettingsDelete();

  const columns: ColumnsType<MatrixWhatsappSettings> = [
    { key: 'title', dataIndex: 'title', title: 'Titulo', ellipsis: true },
    {
      key: 'message',
      dataIndex: 'message',
      title: 'Mensagem',
      ellipsis: true,
    },
    {
      key: 'action',
      title: 'Ação',
      align: 'right',
      fixed: 'right',
      render: (_, row) => (
        <Space key={row.id}>
          <EditIcon
            iconProps={{
              onClick: () => {
                modalToggleAction.open();
                setRowEdit(row);
              },
            }}
          />

          <Divider type="vertical" />

          <DeleteIcon
            onClick={() =>
              Modal.confirm({
                title: (
                  <Group gap={10}>
                    Deseja realmente excluir este template:
                    <strong>"{row.title}"</strong>
                  </Group>
                ),
                content:
                  'Ao remover o template, a recuperação do mesmo não poderá ser feita. Ainda sim deseja continuar?',
                onOk: async () => await remove(row.id),
                width: 700,
                okType: 'danger',
              })
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="page">
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page-header">
        <Title level={width < 576 ? 5 : 4}>
          {intl.formatMessage({ id: route.name })}
        </Title>

        <Button
          type="primary"
          onClick={() => {
            modalToggleAction.open();
            setRowEdit(undefined);
          }}
        >
          Criar
        </Button>
      </div>

      <Divider />

      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: getTableScrollX(columns) }}
        loading={isLoading}
        pagination={false}
      />

      <WhatsappTemplatesModal
        open={modalToggle}
        onCancel={modalToggleAction.close}
        data={rowEdit}
      />
    </div>
  );
};

export default WhatsappTemplates;
